import type { DemoSet } from '../../types'
import { magicScienceInsight } from './insight'
import { amazonFbaCoverage } from './scripts/amazonFbaCoverage'

export const magicScienceSet: DemoSet = {
  id: 'magic-science',
  name: 'Magic Science',
  description:
    "Specialty-chemical manufacturer demo for Nolan Springer (VP Ops). One act, three clicks: Amazon FBA Coverage dashboard → drill into MS-HCL-001 hero SKU with modeled risk band → +30% demand scenario → optional push-to-team. Delivers Nolan's 5/7 verbatim sentence ('their algorithm plus their math plus our demand plan, make this now, buy this here, arrive here') as a working interface.",
  scripts: [amazonFbaCoverage],
  insight: magicScienceInsight,
  userPersona: {
    firstName: 'Nolan',
    lastName: 'Springer',
  },
}
